function initIvoryBudget(){
 const form=document.querySelector('#ib-product-form');
 if(form&&!form.dataset.ready){
  form.dataset.ready='true';
  const sync=()=>{const selected=form.querySelector('input[name=id]:checked');if(!selected)return;
   document.querySelectorAll('[data-ib-price]').forEach(el=>el.textContent=selected.dataset.price);
   document.querySelectorAll('[data-ib-name]').forEach(el=>el.textContent=selected.dataset.name||'Selected bundle');
   document.querySelectorAll('[data-ib-close-price]').forEach(el=>{el.replaceChildren();if(selected.dataset.compare){const was=document.createElement('s');was.className='ib-was';const sr=document.createElement('span');sr.className='ib-sr';sr.textContent='Regular price ';was.append(sr,selected.dataset.compare);el.append(was,' ');}el.append(selected.dataset.price);});
   document.querySelectorAll('button[form="ib-product-form"],#ib-product-form button[type="submit"]').forEach(el=>el.disabled=selected.disabled);
  };form.addEventListener('change',sync);sync();
  form.addEventListener('submit',function(e){
   const selected=form.querySelector('input[name=id]:checked');
   if(!selected||selected.disabled)return;
   if(form.dataset.ibSubmitting==='true'){e.preventDefault();return;}
   e.preventDefault();
   form.dataset.ibSubmitting='true';
   const button=form.querySelector('button[type="submit"]');
   if(button)button.disabled=true;
   fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:selected.value,quantity:1})})
    .then(function(response){if(!response.ok)throw new Error('cart-add-failed');return response.json();})
    .then(function(){setTimeout(function(){window.location.assign('/checkout');},450);})
    .catch(function(){form.dataset.ibSubmitting='';if(button)button.disabled=false;form.submit();});
  });
 }
 const track=document.querySelector('.ib-review-track');
 if(!track)return;
 document.querySelectorAll('[data-ib-review]').forEach(button=>{
  if(button.dataset.ready)return;button.dataset.ready='true';
  button.addEventListener('click',()=>{
   const cards=[...track.querySelectorAll('article')];if(!cards.length)return;
   const step=cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||0);
   const end=track.scrollWidth-track.clientWidth;
   const direction=Number(button.dataset.ibReview);
   let target=track.scrollLeft+step*direction;
   if(direction>0&&track.scrollLeft>=end-2)target=0;
   if(direction<0&&track.scrollLeft<=2)target=end;
   track.scrollTo({left:Math.max(0,Math.min(end,target)),behavior:document.documentElement.classList.contains('mv-motion')?'smooth':'instant'});
  });
 });
}
 document.addEventListener('DOMContentLoaded',initIvoryBudget);document.addEventListener('shopify:section:load',initIvoryBudget);
